<template>
  <div class="p-8 mt-10 bg-stone-100" v-if="properties">
    <div class="mx-auto max-w-7xl">
      <h1 class="text-base font-semibold text-gray-700">
        More available in the same area
      </h1>
      <div class="grid grid-cols-2 gap-4 pt-8 md:grid-cols-6">
        <div class="col-span-4">
          <div class="grid grid-cols-2 gap-4 md:grid-cols-4">
            <div v-for="property in properties.slice(0, 4)" :key="property.id">
              <button
                @click.prevent="handlePropertyClick(property, routeName)"
                @mouseover="handleAdHoverStart()"
                @mouseout="handleAdHoverEnd(property.id)"
                class="flex flex-col shadow-sm"
              >
                <img :src="property.photos[0]" :alt="property.title" />
                <div class="flex flex-col p-4 space-y-2 bg-white">
                  <p
                    class="text-xs font-light text-gray-400 truncate text-start"
                    v-if="property.property_type"
                  >
                    {{ property.property_type.name }}
                  </p>
                  <p class="text-sm uppercase text-start">
                    {{ formattedAmount(Number(property.price, 2)) }}
                  </p>
                  <p class="text-xs truncate text-start">
                    {{ property.address }},
                  </p>
                  <p class="text-xs text-start">
                    {{ property.town.name }}, Ghana
                  </p>
                  <div class="flex flex-row mt-2 space-x-4">
                    <div
                      class="flex items-center"
                      v-if="property.number_of_beds"
                    >
                      <BedSvg color="black" height="4" width="4" />
                      <p class="pl-1 text-xs font-light text-gray-600">
                        {{ property.number_of_beds }}
                      </p>
                    </div>
                    <div
                      class="flex items-center"
                      v-if="property.number_of_baths"
                    >
                      <BathSvg color="black" height="4" width="4" />
                      <p class="pl-1 text-xs font-light text-gray-600">
                        {{ property.number_of_baths }}
                      </p>
                    </div>
                    <div
                      class="flex items-center"
                      v-if="property.property_size"
                    >
                      <PropertySizeSvg color="black" height="3" width="3" />
                      <p class="pl-1 text-xs font-light text-gray-600 truncate">
                        {{ property.property_size.slice(0, 10) }}
                      </p>
                    </div>
                  </div>
                </div>
              </button>
            </div>
          </div>
        </div>
        <div
          class="flex flex-col items-center justify-center p-3 mx-auto bg-white md:w-96 md:p-0"
        >
          <div class="flex flex-col items-center px-8 pb-5 space-y-1">
            <div class="p-8 bg-gray-200"></div>
            <h1 class="font-bold">New property alerts!</h1>
            <h2 class="text-center">Get notified with new properties</h2>
          </div>
          <p
            v-show="showMessage"
            class="text-sm font-semibold text-center text-teal-600"
          >
            {{ message }}
          </p>
          <div class="flex px-4 mx-auto mt-5">
            <input
              type="text"
              placeholder="Email"
              class="p-1 border border-[#ccc] rounded placeholder:text-start focus:outline outline-primary outline-1"
              v-model="email"
              id=""
            />
            <button
              @click="JoinNewsletter"
              class="p-2 ml-2 text-xs font-bold text-center border border-[#ccc] hover:text-white hover:bg-primary rounded md:text-sm text-secondary"
            >
              Notify me
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import axios from "axios";
import PropertySizeSvg from "@/components/svg/PropertySizeSvg.vue";
import BedSvg from "@/components/svg/BedSvg.vue";
import BathSvg from "@/components/svg/BathSvg.vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { useProperties } from "@/composables/useProperties";

export default {
  components: {
    PropertySizeSvg,
    BedSvg,
    BathSvg,
  },
  props: {
    properties: Object,
  },
  setup() {
    // Define reactive state
    const email = ref(null);
    const message = ref(null);
    const showMessage = ref(false);
    const store = useStore();
    const router = useRouter();
    const base_url = store.state.baseUrl;
    const routeName = router.currentRoute.value.fullPath;

    const { handleAdHoverStart, handleAdHoverEnd, handlePropertyClick } =
      useProperties();

    const JoinNewsletter = async () => {
      try {
        const response = await axios.post(`${base_url}newsletter`, {
          email: email.value,
        });
        message.value = response.data.message;
        showMessage.value = true;
        email.value = null;
        setTimeout(() => {
          message.value = null;
          showMessage.value = false;
        }, 5000);
      } catch (error) {
        console.log(error);
      }
    };

    return {
      handleAdHoverStart,
      handleAdHoverEnd,
      handlePropertyClick,
      routeName,
      email,
      message,
      showMessage,
      JoinNewsletter,
    };
  },
};
</script>
